const isInView = (element) => {
  const rect = element.getBoundingClientRect()
  var elTop = rect.top
  var elBottom = rect.bottom

  // (Partially visible elements return true)
  return elTop < window.innerHeight && elBottom >= 0
}

export { isInView }
